import { useRouter } from 'next/navigation';
import { ReactNode, useCallback } from 'react';
import { AppState, Auth0Context, Auth0ContextInterface, Auth0Provider } from '../../auth';
import { sessionStorageCache } from '../../auth/session-storage-cache';
import { config } from '../../config/environment';

interface AuthProviderProps {
  children: ReactNode;
}

const archiveAuthContext: Auth0ContextInterface = {
  isAuthenticated: false,
  isLoading: false,
  user: undefined,
  error: undefined,
  redirecting: false,
  buildAuthorizeUrl: async () => '#',
  buildLogoutUrl: () => '#',
  getAccessTokenSilently: async () => '',
  getAccessTokenWithPopup: async () => '',
  getIdTokenClaims: async () => {
    throw new Error('ID token claims are not available in archive mode.');
  },
  loginWithRedirect: async () => undefined,
  loginWithPopup: async () => undefined,
  logout: () => undefined,
  handleRedirectCallback: async () => {
    throw new Error('Redirect auth callback is disabled in archive mode.');
  },
};

export const AuthProvider = (props: AuthProviderProps) => {
  const router = useRouter();

  const onRedirectCallback = useCallback(
    (appState?: AppState): void => {
      router.replace(appState?.returnTo || '/');
    },
    [router],
  );

  if (config.platformMode === 'archive') {
    return (
      <Auth0Context.Provider value={archiveAuthContext}>{props.children}</Auth0Context.Provider>
    );
  }

  return (
    <Auth0Provider
      {...config.auth0}
      cache={sessionStorageCache}
      useRefreshTokens={true}
      onRedirectCallback={onRedirectCallback}
      {...props}
    />
  );
};
